import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import SignedDocumentsListItem from '../../../../commonComponents/signedDocuments/SignedDocumentsListItem';
import SignedFileProp from '../../../../commonComponents/propTypes/signedFileProp';

function DocumentsList(props) {
  const { t, title, documents, onRemoveClick } = props;
  const existDocuments = documents?.length > 0;

  return (
    <div>
      <h4>{title}</h4>
      <div className="documents-container">
        {existDocuments ? (
          <>
            {documents.map(doc => (
              <SignedDocumentsListItem
                key={doc._id}
                file={doc}
                size="small"
                onRemoveClick={onRemoveClick ? () => onRemoveClick(doc) : null}
              />
            ))}
          </>
        ) : (
          <p className="no-data-hint">{t('report.documents.notFound')}</p>
        )}
      </div>
    </div>
  );
}

DocumentsList.propTypes = {
  t: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  documents: PropTypes.arrayOf(PropTypes.shape(SignedFileProp.propType)),
  onRemoveClick: PropTypes.func,
};

DocumentsList.defaultProps = {
  documents: [],
  onRemoveClick: null,
};

export default translate(DocumentsList);
